import { X, AlertCircle, ArrowLeft } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';

interface CancellationModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const CancellationModal = (props: CancellationModalProps) => {
    // console.log('CancellationModal rendering');
    const { t } = useTranslation();
    const [showCancellationModal, setShowCancellationModal] = useState(false);
    return (
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
        onClick={() => {
          setShowCancellationModal(false);
          props.onClose();
        }}
      >
        <div 
          className="bg-white rounded-2xl max-w-md w-full p-8 text-center relative"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Close button */}
          <button
            onClick={() => {
              setShowCancellationModal(false);
              props.onClose();
            }}
            className="absolute top-4 right-4 p-1 hover:bg-gray-100 rounded-full transition-colors"
          >
            <X className="w-5 h-5 text-gray-500" />
          </button>
          
          <div className="mb-6">
            <div className="mx-auto w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mb-4">
              <AlertCircle className="w-8 h-8 text-orange-600" />
            </div>
            <div className="flex justify-center mb-2">
              <ArrowLeft className="w-6 h-6 text-orange-500" />
            </div>
          </div>
          
          <h3 className="text-2xl font-bold text-gray-900 mb-2">
            {t('subscription.cancelled.title', 'Payment Cancelled')}
          </h3>
          
          <p className="text-gray-600 mb-6">
            {t('subscription.cancelled.message')}
          </p>
          <div className="space-y-3">            
            <button
              onClick={() => {
                setShowCancellationModal(false);
                props.onClose();
              }}
              className="w-full bg-gray-100 text-gray-700 py-3 px-6 rounded-lg font-semibold hover:bg-gray-200 transition-all"
            >
              {t('subscription.cancelled.close', 'Close')}
            </button>
          </div>
        </div>
      </div>
    );
  };

export default CancellationModal